import {
  CloseOutline18Icon,
  TimeOutline18Icon,
} from "@vygruppen/spor-icon-react";
import { FC, useMemo } from "react";
import { DropsButton, Text } from "shared/components/Spor";
import { useTheme } from "styled-components";

type ShowClosedToggleProps = {
  showClosed: boolean;
  onToggle: () => void;
  disabled?: boolean;
};

export const ShowClosedToggle: FC<ShowClosedToggleProps> = ({
  showClosed,
  onToggle,
  disabled = false,
}) => {
  const theme = useTheme();

  const variant = useMemo(() => {
    if (disabled) return "primary" as const;
    if (showClosed) return "secondary" as const;
    return "tertiary" as const;
  }, [disabled, showClosed]);

  return (
    <DropsButton
      variant={variant}
      outline={
        showClosed && !disabled
          ? `1px solid ${theme.colorOutlineFocus}`
          : undefined
      }
      size="xs"
      leftIcon={<TimeOutline18Icon />}
      rightIcon={showClosed ? <CloseOutline18Icon /> : undefined}
      onClick={onToggle}
      fontWeight="normal"
      disabled={disabled}
    >
      <Text variant="xs" fontWeight="normal">
        {showClosed ? "Skjul friskmeldt" : "Vis friskmeldt"}
      </Text>
    </DropsButton>
  );
};
